import PropTypes from 'prop-types';
import { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SeparatorTitle from './SeparatorTitle';

const CollapsibleGroup = ({ children, className, title }) => {
  const [expanded, setExpanded] = useState(true);
  const toggle = () => setExpanded(!expanded);

  return (
    <div className={className}>
      <SeparatorTitle>
        <div className="flex justify-between">
          <div>{title}</div>
          <IconButton className="text-primary-text" onClick={toggle} size="small">
            {expanded ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </IconButton>
        </div>
      </SeparatorTitle>
      {expanded && children}
    </div>
  );
};

CollapsibleGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
};

CollapsibleGroup.defaultProps = {
  className: '',
};

export default CollapsibleGroup;
